<onyx-section [heading]="`${I18N}.heading` | translate">
  <div rightHeading class="heading f-muted">
    <onyx-icon name="tooltip-filled" [size]="16"></onyx-icon>

    <p>{{ 'labels.includeWaitingTime' | translate }}</p>
  </div>

  <form [formGroup]="form()">
    @let control = form().controls.averageServiceTime;
    <onyx-form-group label="labels.averageServiceTime" [controls]="control">
      <onyx-timepicker
        [formControl]="control"
        variant="duration"
        [showErrors]="false"
        [size]="32"
      ></onyx-timepicker>

      <onyx-suggestions
        [control]="control"
        [suggestions]="DURATION_SUGGESTIONS"
      ></onyx-suggestions>
    </onyx-form-group>
  </form>
</onyx-section>
